import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import routes from '../routes'
import { getModuleIdForPath } from '../hooks/useModulePermissions'
import { trackModuleView } from '../utils/heapAnalytics'

function routeBasePath(routePath) {
  if (!routePath) return ''
  return String(routePath).split('/:')[0].split('?')[0]
}

function moduleNameForPath(pathname, moduleId) {
  const path = String(pathname || '').split('?')[0].split('#')[0]
  const exact = routes.find((r) => routeBasePath(r.path) === path)
  if (exact?.pageTitle) return exact.pageTitle
  if (exact?.name) return exact.name

  const byPrefix = routes
    .filter((r) => {
      const base = routeBasePath(r.path)
      return base && base !== '/' && path.startsWith(`${base}/`)
    })
    .sort((a, b) => routeBasePath(b.path).length - routeBasePath(a.path).length)[0]

  if (byPrefix?.pageTitle) return byPrefix.pageTitle
  if (byPrefix?.name) return byPrefix.name
  return moduleId
}

/**
 * Fire Heap `Module` (action=viewed) once per pathname change inside the authenticated shell.
 */
export function useHeapModuleTracking() {
  const location = useLocation()
  const companyId = useSelector((state) => state.companyList?.selectedCompany?.id)
  const lastPathRef = useRef('')

  useEffect(() => {
    const pathname = location.pathname || ''
    if (!pathname || pathname === lastPathRef.current) return
    lastPathRef.current = pathname

    const moduleId = getModuleIdForPath(pathname)
    if (!moduleId) return

    trackModuleView({
      pathname,
      moduleId,
      moduleName: moduleNameForPath(pathname, moduleId),
      companyId,
    })
  }, [location.pathname, companyId])
}
